module.exports = __webpack_public_path__ + "static/media/ecg_wko-500x250.38023a02.jpg";